import React, {Component} from "react";
import {Container} from "react-bootstrap";
import ExtractionForm from "./ExtractionForm";
import {BarLoader} from "react-spinners";
import ExtractionResults from "./ExtractionResults";
import Introduction from "./Introduction";

class Extraction extends Component {
    state = {
        data: null,
        namedEntities: [],
        extractionResults: false,
        classifierResult: null,
        loading: false,
        namedEntityType: '',
        expanded: true
    };

    constructor(props) {
        super(props);
        this.setExtractionResults = this.setExtractionResults.bind(this);
        this.resetResults = this.resetResults.bind(this);
        this.setLoadingBarStatus = this.setLoadingBarStatus.bind(this);
        this.setErrorMessage = this.setErrorMessage.bind(this);
        this.setExpanded = this.setExpanded.bind(this);
    }

    componentDidMount() {
        this.setState({
            loading: false
        });
    }

    setExtractionResults(results) {
        this.setState({
            namedEntities: results.namedEntities,
            concepts: results.concepts,
            terms: results.terms,
            classifierResult: results.classifier[0].classifierResult,
            extractionResults: true,
            loading: false,
            namedEntityType: results.namedEntityType,
            expanded: false
        });
    }

    setErrorMessage(status){
        this.setState({
            extractionResults: false,
            error: true,
            errorMessage: "Server returned " + status,
            loading: false,
        })
    }

    resetResults() {
        this.setState({
            extractionResults: false,
            error: false
        });
    }

    setLoadingBarStatus(status) {
        this.setState({
            loading: status
        });
    }

    setExpanded = () => {
        this.setState(prevState => ({
            expanded: !prevState.expanded
          }));
    };

    render() {
        const documentGenre = (this.state.classifierResult === "ScienceArticle") ? "medical journal abstract" : "news article";

        return (
            <Container className="extractor-body">
                <Introduction/>
                <hr />
                <ExtractionForm
                    loading={this.state.loading}
                    setExtractionResults={this.setExtractionResults}
                    resetExtractionResults={this.resetResults}
                    setLoadingBarStatus={this.setLoadingBarStatus}
                    setErrorMessage={this.setErrorMessage}
                    setExpanded={this.setExpanded}
                    expanded={this.state.expanded}
                />
                <hr />
                <BarLoader
                    css={'display: block; margin: 0 auto;'}
                    loading={this.state.loading}
                    color="#00adee"
                    height={20}
                    width={300}
                />
                {this.state.extractionResults &&
                <ExtractionResults
                    namedEntities={this.state.namedEntities}
                    concepts={this.state.concepts}
                    terms={this.state.terms}
                    classifier={documentGenre}
                    namedEntityType={this.state.namedEntityType}
                />}
                {this.state.error &&
                <div>
                    {this.state.errorMessage}
                </div>
                }
            </Container>
        );
    }

}

export default Extraction;
